import React from 'react';
import { Col } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DetailItem = ({ icon, label, value, color = "primary" }) => (
    <Col md={4} sm={6} className="mb-4">
        <Flex alignItems="center">
            <div className={`icon-item icon-item-sm shadow-none bg-soft-${color} text-${color} me-3 rounded-circle`}>
                <FontAwesomeIcon icon={icon} />
            </div>
            <div>
                <h6 className="mb-0 text-500 fs-11 text-uppercase fw-semi-bold" style={{ letterSpacing: '0.5px' }}>{label}</h6>
                <p className="mb-0 text-900 fs-10 fw-bold">{value || '—'}</p>
            </div>
        </Flex>
    </Col>
);

export default DetailItem;
